export enum RewardType {
	CASH = 'cash',
	PHYSICAL = 'physical',
	VOUCHER = 'voucher',
}
